import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconComponent, IconName } from '@recruitee/user-interface';
import { DataSourceLayout } from '@recruitee/views-types';

export const LAYOUT_ICON_MAP: Record<DataSourceLayout['type'], IconName> = {
  table: 'view-week',
  list: 'view-stream',
  board: 'pipeline',
};

@Component({
  selector: 'rt-views-layout-button',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './layout-button.component.html',
  styleUrls: ['./layout-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutButtonComponent {
  @Input() public icon: IconName;
  @Input() public text: string;
  @Input() public isActive: boolean;
}
